import { all, put, select, takeLatest } from "redux-saga/effects";
import { currentEnv } from "~/configs";
import AppId from "~/utils/partner";
import * as types from "./types";

const urlLogin = currentEnv.MEDPRO_LOGIN;

function* redirectToMedproId() {
  try {
    const schedulesSelected = yield select(
      state => state.totalData.schedulesSelected
    );
    const bookingFlow = schedulesSelected.length > 0 ? "true" : "";
    const { origin, pathname } = window.location;
    // console.log(pathname);
    yield put({ type: types.SET_CURRENT_URL, payload: pathname });
    window.location.href = `${urlLogin}/url=${origin}&partnerId=${AppId}&bookingFlow=${bookingFlow}`;
    // window.location.href = `${urlLogin}?url=${origin}&partnerId=${AppId}&bookingFlow=${bookingFlow}`;
  } catch (error) {
    console.log(error);
  }
}

export default function* watcher() {
  yield all([takeLatest(types.REDIRECT_TO_MEDPRO_ID, redirectToMedproId)]);
}
